var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54331 23.8538C6.93743 22.0263 0 13.8427 0 8.8677C0 3.96975 3.96975 0 8.87091 0C13.7689 0 17.7386 3.96975 17.7386 8.8677C17.7386 13.5087 10.7819 21.9717 9.19209 23.8474C9.02187 24.0465 8.71675 24.053 8.54331 23.8538Z",
    fill: "#155878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5817 17.2031C8.09078 17.2031 7.69281 16.8052 7.69281 16.3142L7.69281 7.88558L5.10703 10.4714C4.75989 10.8185 4.19708 10.8185 3.84995 10.4714L3.53568 10.1571C3.18855 9.80997 3.18855 9.24715 3.53568 8.90002L8.17539 4.26032C8.52252 3.91318 9.08533 3.91318 9.43247 4.26032L14.0722 8.90002C14.4193 9.24716 14.4193 9.80997 14.0722 10.1571L13.7579 10.4714C13.4108 10.8185 12.848 10.8185 12.5008 10.4714L9.91504 7.88558L9.91504 16.3142C9.91504 16.8052 9.51707 17.2031 9.02615 17.2031L8.5817 17.2031Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipper);
export default __webpack_public_path__ + "static/media/Shipper.7dc114fb74a607e3f47f39a7bbac4471.svg";
export { ForwardRef as ReactComponent };